import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=21e9af10"
import script from "./WhatsNew.vue?vue&type=script&lang=ts"
export * from "./WhatsNew.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./WhatsNew.vue?vue&type=style&index=0&id=21e9af10&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports